export enum FundingSource {
  Cash = 'CASH',
  Conventional = 'CONVENTIONAL',
  FHA = 'FHA',
  VA = 'VA',
  USDA = 'USDA',
}
